"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldWrap = exports.FieldBoxPalette = exports.FieldBoxAlign = exports.FieldBoxSize = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const isNil_1 = __importDefault(require("lodash-es/isNil"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var FieldBoxSize;
(function (FieldBoxSize) {
    FieldBoxSize["Large"] = "large";
    FieldBoxSize["Medium"] = "medium";
    FieldBoxSize["Small"] = "small";
    FieldBoxSize["Zero"] = "zero";
})(FieldBoxSize || (exports.FieldBoxSize = FieldBoxSize = {}));
var FieldBoxAlign;
(function (FieldBoxAlign) {
    FieldBoxAlign["Left"] = "left";
    FieldBoxAlign["Center"] = "center";
    FieldBoxAlign["Right"] = "right";
})(FieldBoxAlign || (exports.FieldBoxAlign = FieldBoxAlign = {}));
var FieldBoxPalette;
(function (FieldBoxPalette) {
    FieldBoxPalette["Light"] = "light";
    FieldBoxPalette["Dark"] = "dark";
    FieldBoxPalette["Blue"] = "blue";
    FieldBoxPalette["Transparent"] = "transparent";
})(FieldBoxPalette || (exports.FieldBoxPalette = FieldBoxPalette = {}));
exports.FieldWrap = (0, react_1.forwardRef)(({ before, after, placeholder, children, active, error, align, hint, hinted, palette, }, ref) => {
    const hasHint = !(0, isNil_1.default)(hint);
    return ((0, jsx_runtime_1.jsxs)("div", { ref: ref, className: (0, classnames_1.default)(styles_module_css_1.default.field, {
            [styles_module_css_1.default[align]]: align,
            [styles_module_css_1.default.active]: active,
            [styles_module_css_1.default.error]: error,
            [styles_module_css_1.default.fieldHinted]: hinted,
        }), children: [before && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.before, { [styles_module_css_1.default[`fieldWrap${palette}`]]: palette }), children: before })), (0, jsx_runtime_1.jsxs)("div", { className: styles_module_css_1.default.content, children: [placeholder && (0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.placeholder, children: placeholder }), children] }), after && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.after, { [styles_module_css_1.default[`fieldWrap${palette}`]]: palette }), children: after })), hasHint && ((0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.hint, children: (0, jsx_runtime_1.jsx)("span", { className: styles_module_css_1.default.hintText, children: hint }) }))] }));
});
const FieldBox = react_1.default.forwardRef(({ id, children, error = false, disabled = false, readOnly = false, size = FieldBoxSize.Medium, palette = FieldBoxPalette.Light, fieldType, autoHeight, hinted, focused, unwrap, activeTarget, fieldRef, onClick, ...rest }, ref) => {
    const handleClick = (0, react_1.useCallback)((event) => {
        fieldRef?.current?.focus();
        if (onClick) {
            onClick(event);
        }
    }, [onClick, fieldRef]);
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, jsx_runtime_1.jsx)("div", { ...rest, onClick: handleClick, id: id, "data-field-type": fieldType, ref: ref, className: (0, classnames_1.default)(styles_module_css_1.default.root, {
            [styles_module_css_1.default.error]: error,
            [styles_module_css_1.default.activeTarget]: activeTarget,
            [styles_module_css_1.default.readOnly]: readOnly,
            [styles_module_css_1.default.disabled]: disabled,
            [styles_module_css_1.default.interactive]: onClick,
            [styles_module_css_1.default.hinted]: hinted,
            [styles_module_css_1.default.focused]: focused,
            [styles_module_css_1.default[size]]: size,
            [styles_module_css_1.default[palette]]: palette,
            [styles_module_css_1.default.autoHeight]: autoHeight,
            [styles_module_css_1.default.unwrap]: unwrap,
        }), children: children }));
});
exports.default = FieldBox;
